import {Injectable} from '@angular/core';
import {Person, StammdatenNatuerlichePerson} from '@nachdigal';
import {AbstractMapper} from '../../abstract.mapper';

@Injectable()
export class PersonMapperService extends AbstractMapper<StammdatenNatuerlichePerson, Person> {

  protected mapInternal(source: StammdatenNatuerlichePerson): Person {

    return {
      vorname: source.vorname,
      nachname: source.nachname,
      geburtsname: source.geburtsname,
      namensvorsatz: source.namensvorsatz,
      namenszusatz: source.namenszusatz,
      titel: source.titel,
      geburtsdatum: source.geburtsdatum,
      religionsschluessel: source.religionsschluessel,
      beruf: source.beruf
    };
  }
}
